import { useQuery } from '@tanstack/react-query';
import useFetch from './useFetch';
import {
  EntrepreneurPlatformAccess,
  EntrepreneurPlatform,
} from '@/config/entrepreneurPlatforms';

interface EntrepreneurAccessesResponse {
  accesses: EntrepreneurPlatformAccess[];
}

export const ENTREPRENEUR_ACCESSES_QUERY_KEY = ['entrepreneurAccesses'];

/**
 * Fetch every B2C platform membership (foundershub / gaia) of the current
 * entrepreneur. Shared by FoundersHub and Gaia surfaces — a single source of
 * truth for "which platforms does this client have access to".
 */
export const useEntrepreneurAccesses = (enabled: boolean = true) => {
  const { doFetch } = useFetch();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ENTREPRENEUR_ACCESSES_QUERY_KEY,
    queryFn: async (): Promise<EntrepreneurAccessesResponse> => {
      return doFetch('/entrepreneur/auth/accesses');
    },
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled,
  });

  const accesses = data?.accesses ?? [];

  const getAccess = (platform: EntrepreneurPlatform) =>
    accesses.find((a) => a.platform === platform);

  return { accesses, getAccess, isLoading, error, refetch };
};
